export default "__VITE_ASSET__yDZva0QO__"